// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__tknHB","header":"PrivacyPolicy_header__tK551","subHeader":"PrivacyPolicy_subHeader__JdYQC"};